module.exports = __webpack_public_path__ + "static/media/n1.e808c4e8.png";